function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
import "core-js/modules/es6.array.find.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.object.define-property.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es6.array.for-each.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import "core-js/modules/es6.object.define-properties.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es7.symbol.async-iterator.js";
import "core-js/modules/es6.object.create.js";
import "core-js/modules/es6.object.get-prototype-of.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.object.set-prototype-of.js";
import "core-js/modules/es6.array.slice.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import cloneDeep from 'lodash/cloneDeep';
import { mapState } from 'vuex';
import WidgetChartOptionsEditor from './chart/widgetChartOptionsEditor.vue';
import WidgetChartDataOptionsEditor from './chart/widgetChartDataOptionsEditor.vue';
import WidgetTwinTableOptionsEditor from './twinTable/widgetTwinTableOptionsEditor.vue';
import WidgetTwinMapOptionsEditor from './twinMap/widgetTwinMapOptionsEditor.vue';
import TwinFilterEditor from './twinFilterEditor.vue';
import api from '@/services/apiService/dashboards';
import _get from 'lodash/get';
import TwinMapPopupEditor from './twinMap/twinMapPopupEditor.vue';
import TwinMapActionsEditor from './twinMap/twinMapActionsEditor.vue';
import debounce from 'lodash/debounce';
import WidgetMetaEditor from './widgetMetaEditor.vue';
import ChartCustomOptionsEditorCodeEditor from './chart/custom/chartCustomOptionsEditorCodeEditor.vue';
import TwinMapMarkerOptionsEditor from './twinMap/twinMapMarkerOptionsEditor.vue';
export default {
  name: 'WidgetEditDialog',
  components: {
    WidgetCard: function WidgetCard() {
      return import('./widgetCard.vue');
    },
    WidgetChartOptionsEditor: WidgetChartOptionsEditor,
    WidgetChartDataOptionsEditor: WidgetChartDataOptionsEditor,
    WidgetTwinTableOptionsEditor: WidgetTwinTableOptionsEditor,
    WidgetTwinMapOptionsEditor: WidgetTwinMapOptionsEditor,
    TwinFilterEditor: TwinFilterEditor,
    TwinMapPopupEditor: TwinMapPopupEditor,
    TwinMapActionsEditor: TwinMapActionsEditor,
    WidgetMetaEditor: WidgetMetaEditor,
    ChartCustomOptionsEditorCodeEditor: ChartCustomOptionsEditorCodeEditor,
    TwinMapMarkerOptionsEditor: TwinMapMarkerOptionsEditor
  },
  props: {
    value: {
      type: Boolean,
      required: true
    },
    dashboardId: {
      type: String,
      required: true
    },
    widgetId: {
      type: String,
      required: true
    },
    dateRange: {
      type: Object,
      required: true
    },
    customParameters: {
      type: Object,
      required: false,
      "default": function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      tabItem: 'general',
      isSaving: false,
      editedWidget: null,
      dataSet: {},
      isFetchingDataSet: false,
      formValid: false,
      showOptionsPreview: false
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState('dashboards', ['dashboards'])), mapState('app', ['inpOutlined', 'color', 'inpFilled'])), {}, {
    dashboard: function dashboard() {
      var _this = this;
      return this.dashboards.find(function (dashboard) {
        return dashboard.id === _this.dashboardId;
      });
    },
    widget: function widget() {
      var _this2 = this;
      if (!this.dashboard) {
        return null;
      }
      if (this.isCreating) {
        return {
          id: '__new',
          title: '',
          size: 1,
          layoutOrderIdx: this.dashboard.value.widgets.length,
          type: 'empty',
          twinFilter: {}
        };
      }
      return this.dashboard.value.widgets.find(function (widget) {
        return widget.id === _this2.widgetId;
      });
    },
    isCreating: function isCreating() {
      return this.widgetId === '__new';
    },
    twinFilter: {
      get: function get() {
        return _get(this.editedWidget, 'twinFilter', {});
      },
      set: function set(val) {
        var clone = cloneDeep(this.editedWidget);
        clone.twinFilter = val;
        this.editedWidget = clone;
      }
    }
  }),
  watch: {
    widget: {
      handler: function handler(newVal, oldVal) {
        if (JSON.stringify(newVal) === JSON.stringify(oldVal)) {
          return;
        }
        this.editedWidget = cloneDeep(newVal);
      },
      deep: true,
      immediate: true
    },
    editedWidget: {
      handler: function handler() {
        if (!this.editedWidget) {
          return;
        }
        this.fetchDataSet();
      },
      deep: true,
      immediate: true
    },
    value: {
      handler: function handler(isOpen) {
        if (!isOpen) {
          return;
        }
        this._fetchDataSet();
      }
    }
  },
  methods: {
    get: _get,
    fetchDataSet: debounce(function () {
      this._fetchDataSet();
    }, 400),
    _fetchDataSet: function _fetchDataSet() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var result;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (_this3.value) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              _context.prev = 2;
              _this3.isFetchingDataSet = true;
              _context.next = 6;
              return api.fetchDataForWidget(_this3.dashboardId, _this3.editedWidget, _this3.dateRange, _this3.customParameters);
            case 6:
              result = _context.sent;
              _this3.dataSet = {
                data: result,
                success: true
              };
              _context.next = 14;
              break;
            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](2);
              console.error('error', _context.t0);
              _this3.dataSet = {
                data: null,
                success: false,
                error: _context.t0
              };
            case 14:
              _context.prev = 14;
              _this3.isFetchingDataSet = false;
              return _context.finish(14);
            case 17:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[2, 10, 14, 17]]);
      }))();
    },
    save: function save() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var chartOptions, twinTableOptions, twinMapOptions, widgetConfig, storeAction, _yield$_this4$$store$, success, error;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this4.$refs.form.validate();
              if (_this4.formValid) {
                _context2.next = 4;
                break;
              }
              _this4.$snack(_this4.$t('Dashboards.components.widgetEditDialog.snack.error.formInvalid'), 'error');
              return _context2.abrupt("return");
            case 4:
              _this4.isSaving = true;
              if (_this4.editedWidget.type === 'chart') {
                chartOptions = _this4.editedWidget.chartOptions;
              }
              if (_this4.editedWidget.type === 'twin-table') {
                twinTableOptions = _this4.editedWidget.twinTableOptions;
              }
              if (_this4.editedWidget.type === 'twin-map') {
                twinMapOptions = _this4.editedWidget.twinMapOptions;
              }
              widgetConfig = _objectSpread(_objectSpread({}, _this4.editedWidget), {}, {
                chartOptions: chartOptions,
                twinTableOptions: twinTableOptions,
                twinMapOptions: twinMapOptions
              });
              storeAction = 'dashboards/changeWidgetConfig';
              if (_this4.isCreating) {
                storeAction = 'dashboards/addWidget';
              }
              _context2.next = 13;
              return _this4.$store.dispatch(storeAction, _defineProperty({
                dashboardId: _this4.dashboardId,
                widgetId: _this4.isCreating ? undefined : _this4.widgetId
              }, _this4.isCreating ? 'widget' : 'config', widgetConfig));
            case 13:
              _yield$_this4$$store$ = _context2.sent;
              success = _yield$_this4$$store$.success;
              error = _yield$_this4$$store$.error;
              _this4.isSaving = false;
              if (success) {
                _context2.next = 21;
                break;
              }
              console.error(error);
              _this4.$snack('Could not save widget, see browser console for details', 'error');
              return _context2.abrupt("return");
            case 21:
              _this4.$emit('saved');
            case 22:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    setTwinFilter: function setTwinFilter(val) {
      var clone = cloneDeep(this.editedWidget);
      clone.twinFilter = val;
      this.editedWidget = clone;
    }
  }
};